import React from 'react';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';
import { useJiraServiceManagementProjectNavigation } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/common/project-sidebar-navigation-resource/index.tsx';

export const SERVICE_DESK_PRODUCT = 'servicedesk';

export const defaultRedirectForSettings =
	(product: string) =>
	({ match }: RouteContext) => {
		const { data } = useJiraServiceManagementProjectNavigation();

		if (!fg('vmc-11-manage-versions-permission')) {
			return (
				<Redirect
					to={`/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`}
				/>
			);
		}

		if (
			data?.permissionInfo?.isAdmin ||
			data?.permissionInfo?.isSiteAdmin ||
			data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS
		) {
			return (
				<Redirect
					to={`/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`}
				/>
			);
		}

		if (data?.permissionInfo?.projectPermissionsQueried?.MANAGE_VERSIONS === true) {
			return (
				<Redirect
					to={`/plugins/servlet/project-config/${String(match.params.projectKey)}/administer-versions`}
				/>
			);
		}

		return (
			<Redirect
				to={`/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`}
			/>
		);
	};
